import React from "react";
import { Trans } from "react-i18next";
import Popup, { PopupActions, PopupButton, PopupContent, PopupHeading, PopupTextContent, } from "../../../components/Common/Popup";
const AddTemplateProductToCartWarningDialog = ({ handleCancel, handleAddToCart, }) => {
    return (React.createElement(Popup, { open: true, onClose: handleCancel },
        React.createElement(PopupHeading, null,
            React.createElement(Trans, null, "Dear customer")),
        React.createElement(PopupContent, null,
            React.createElement(PopupTextContent, null,
                React.createElement("p", null,
                    React.createElement(Trans, null, "The product will be produced exactly as shown on screen. Check image positioning and text carefully before adding to your shopping cart.")))),
        React.createElement(PopupActions, null,
            React.createElement(PopupButton, { onClick: handleAddToCart, secondary: "" },
                React.createElement(Trans, null, "Add to shopping cart")),
            React.createElement(PopupButton, { onClick: handleCancel, secondary: "" },
                React.createElement(Trans, null, "Yes, I would like to check")))));
};
export default AddTemplateProductToCartWarningDialog;
